import React, { useCallback, useEffect, useState } from 'react';
import { Card, Row, Col } from 'antd';
import HeadingTypography from '../../shared/Typography/Heading';
import TextTypography from '../../shared/Typography/Text';
import { getLeadsCount } from 'src/app/services/lead';
import { useLeadContext } from '@contexts';

const leadStats = {
    'Total Leads': 0,
    Approved: 0,
    'Drop-off': 0,
    Declined: 0,
    'Total Guarantors': 0,
};
interface LeadStatsType {
    'Total Leads': number;
    Approved: number;
    'Drop-off': number;
    Declined: number;
    'Total Guarantors': number;
}

const LeadStatsCards: React.FC = () => {
    const { date } = useLeadContext();

    const [data, setData] = useState<LeadStatsType>(leadStats);
    const fetchLeadsCount = useCallback(async () => {
        const resp = await getLeadsCount(date);
        setData({
            'Total Leads': resp?.totalLeads ?? 0,
            Approved: resp?.creditStatusCounts?.approved ?? 0,
            'Drop-off': resp?.droppedLeads ?? 0,
            Declined: resp?.creditStatusCounts?.rejected ?? 0,
            'Total Guarantors': resp?.totalGuarantors ?? 0,
        });
    }, [date.startDate,date.endDate]);
    useEffect(() => {
        fetchLeadsCount();
    }, [fetchLeadsCount]);

  return (
    <div className="pt-6">
      <div className="flex w-full gap-4">
        {Object.entries(data).map(([key, value], index) => (
          <div key={index} className="flex-1 min-w-0">
            <Card bordered={false} className="rounded-xl shadow-md bg-white h-full">
              <div className="flex justify-between items-center">
                <HeadingTypography fontSize={16}>{key}</HeadingTypography>
                <TextTypography fontSize={16}>{value}</TextTypography>
              </div>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LeadStatsCards;
